export enum SubSystem {
    OUTAGE = <any>'Outage',
    CONNECTION = <any>'Connection'
}